import React, { useContext, useState } from 'react';
import { Button, Col, Row, Table } from 'reactstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import _ from 'lodash';
import { ItemDropdownMenu } from '.';
import { dateHelpers, reportHelpers, UserContext } from '../utils';

export default function QuotesGrid(props) {
  const { currentUser } = useContext(UserContext);
  const [working, setWorking] = useState();

  function getExcel() {
    setWorking(true);
    props.exportXlsxCallback();
    setWorking(false);
  }

  let alreadyDisplayed = [];
  return (
    <>
      <Row className="align-items-center mt-3 mb-2">
        <Col className="transparent-background">
          {props.data && props.data.length && props.exportXlsxCallback
            ? (<Button
              title="Download as .xlsx"
              className="shredButtonExcel float-end ms-2"
              onClick={getExcel}
              disabled={working}
            >
              <FontAwesomeIcon icon="file-excel" size="lg" />
            </Button>)
            : null
          }
        </Col>
      </Row>
      <Table size="sm" className="data-table">
        <thead className="table-header">
          <tr>
            <th style={{ width: "5%" }}>Quote</th>
            <th style={{ width: "5%" }}>{<span>Quote<br />Date</span>}</th>
            {props.fromSales &&
               <th style={{ width: "20%" }}>Customer</th>
            }
            <th style={{ width: "20%" }}>Customer Part</th>
            {!currentUser?.isAnyCustomerTypeRole &&
              <th style={{ width: "25%" }}>Item</th>
            }
            <th style={{ width: "10%" }}>{<span>Ship<br />Method</span>}</th>
            <th style={{ width: "5%" }}>Qty</th>
            <th style={{ width: "5%" }}>{<span>Qty<br />Available</span>}</th>
            <th style={{ width: "5%" }}>Expires</th>
          </tr>
        </thead>
        <tbody>
          {_.map(props.data, (qr, ind) => {
            const displayed = _.includes(alreadyDisplayed, qr.quoteId);
            alreadyDisplayed.push(qr.quoteId);
            return (
              <tr key={ind} className={`tr-${ind % 2 === 0 ? "primary" : "secondary"}`}>
                {displayed ? <td className='data-cell'/> : <td className="data-cell" children={qr.quoteId} />}
                {displayed ? <td className='data-cell'/> : <td className="data-cell" children={dateHelpers.toLongDateString(qr.quoteDate)} />}
                {props.fromSales &&
                  <td className="data-cell" children={qr.customerWithName} />
                }
                <td
                  className="data-cell"
                  onClick={() => reportHelpers.getCustomerSpecReport(qr.customerId, qr.item)}
                  title="Print Customer Spec Report"
                >
                  <span className="shredLink fw-bold cursor-pointer">{qr.customerItem}</span>
                </td>
                {!currentUser?.isAnyCustomerTypeRole &&
                  <ItemDropdownMenu
                    itemNumber={qr.item}
                    itemDescription={qr.itemWithDesc}
                    attachmentCount={qr.itemAttachmentCount}
                  />}
                <td className="data-cell" children={qr.shipMethod} />
                <td className="data-cell" children={qr.quantity.toLocaleString()} />
                <td className="data-cell" children={qr.qtyAvailable.toLocaleString()} />
                <td className="data-cell" children={dateHelpers.toLongDateString(qr.quoteExpires)} />
              </tr>
            )
          })}
        </tbody>
      </Table>
    </>
  )
}
